var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"viewBox":_vm.viewBox}},[_c('g',{attrs:{"fill":_vm.color}},[_c('path',{attrs:{"stroke":_vm.color,"stroke-linecap":"butt","stroke-linejoin":"miter","stroke-width":"3","d":"M23.05694516 7.5569495l-16-.00000867"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }